export default "__VITE_ASSET__09c59515__"